module.exports = __webpack_public_path__ + "c2dda40b5c3df7f16ed9106c3649c07b.png";